
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const PlatformDomainCrudService = function(props: 
  CrudServiceProps<api.PlatformDomain,string>
) {
  
  return CrudApiService<api.PlatformDomain,string>({...props, api: api, entityName: 'PlatformDomain'});

};